<template>
  <c-modal
    class="onboarding-modal-container"
    name="onboarding"
    v-bind="$attrs"
    v-on="$listeners"
    hide-close
    modal-size="650px"
  >
    <onboarding-modal
      @close="closeModal"
    />
  </c-modal>
</template>

<script>
import OnboardingModal from '@/components/Login/Onboarding/OnboardingModal'

export default {
  components: {
    OnboardingModal
  },
  methods: {
    closeModal () {
      this.touched = false

      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@style/reference';

.onboarding-modal-container ::v-deep .c-modal {
    width: 650px !important;
    height: 450px;

    @include tablet {
      width: 100% !important;
      max-width: 400px;
      height: 430px;
      top: auto;
    }

    @include mobile {
      width: 100% !important;
      max-width: 316px;
      height: 430px;
      top: auto;
    }
  }

</style>



// WEBPACK FOOTER //
// src/containers/Login/OnboardingModalContainer.vue